<script>
  function go() {
    document.location='https://dust.supply'
  }
</script>

<button on:click={go}>
	<slot/>
</button>

<style>
	button {
    position: fixed;
    left: 0;
    bottom: 0;
    margin-left: 5%;
    margin-bottom: 15%;
    padding-top: 10px;
		padding-bottom:10px;
		padding-left:10px;
		padding-right:0px;
		background-color: transparent;
		color: white;
		border: none;
    padding: 0;
		text-transform: uppercase;
    font-family: monospace;
    cursor: crosshair;
		z-index: 10;
	}

	:global(body.dark-mode) button {
		background-color: transparent;
		color: black;
	}
</style>
